class LocalStorageManage {
    isAvailable() {
        try {
            if (typeof window === "undefined" || !window.localStorage) return false;
            const testKey = "__lsm_test__";
            window.localStorage.setItem(testKey, "1");
            window.localStorage.removeItem(testKey);
            return true;
        } catch {
            return false;
        }
    }

    cleanupExpired() {
        if (!this.isAvailable()) return;

        const now = Date.now();
        const { localStorage } = window;

        for (let i = localStorage.length - 1; i >= 0; i -= 1) {
            const key = localStorage.key(i);
            if (!key) continue;

            const raw = localStorage.getItem(key);
            if (!raw) continue;

            try {
                const parsed = JSON.parse(raw);
                if (
                    parsed &&
                    typeof parsed === "object" &&
                    typeof parsed.expiry === "number" &&
                    now > parsed.expiry
                ) {
                    localStorage.removeItem(key);
                }
            } catch {
                // ignore non-JSON values
            }
        }
    }

    setWithExpiry(key, value, ttl = 600000) {
        if (!this.isAvailable()) return false;

        const now = Date.now();
        const item = { value, expiry: now + ttl };
        const payload = JSON.stringify(item);

        try {
            window.localStorage.setItem(key, payload);
            return true;
        } catch (error) {
            // Most common cause: QuotaExceededError (storage full).
            // Try removing expired cached entries, then retry once.
            this.cleanupExpired();
            try {
                window.localStorage.setItem(key, payload);
                return true;
            } catch {
                // Don't crash the app on cache write failures.
                console.warn("LocalStorageManage: failed to write cache key", key, error);
                return false;
            }
        }
    }

    getWithExpiry(key) {
        if (!this.isAvailable()) return null;

        const itemStr = window.localStorage.getItem(key);
        if (!itemStr) return null;

        let item;
        try {
            item = JSON.parse(itemStr);
        } catch {
            window.localStorage.removeItem(key);
            return null;
        }

        if (!item || typeof item !== "object" || typeof item.expiry !== "number") {
            return null;
        }

        if (Date.now() > item.expiry) {
            window.localStorage.removeItem(key);
            return null;
        }

        return item.value;
    }
}

export default LocalStorageManage;
